import { render, staticRenderFns } from "./cooperative.vue?vue&type=template&id=423e5f4e&scoped=true"
import script from "./cooperative.vue?vue&type=script&lang=js"
export * from "./cooperative.vue?vue&type=script&lang=js"
import style0 from "./cooperative.vue?vue&type=style&index=0&id=423e5f4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e5f4e",
  null
  
)

export default component.exports